<script setup lang="ts">
/**
 * Show page header for resource pages (tags, item types, people, etc.).
 * Colored icon + title + subtitle on the left, Edit + Delete buttons on the right.
 */
import { ICON } from "@/lib/icons"

defineProps<{
  /** Lucide icon name (e.g. "i-lucide-tags") */
  icon: string
  /** Inline style for the icon (typically { color: hex }) */
  iconStyle?: Record<string, string>
  /** Primary heading text */
  title: string
  /** Subtitle below the heading (e.g. "12 items") */
  subtitle: string
}>()

const emit = defineEmits<{
  edit: []
  delete: []
}>()
</script>

<template>
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-2">
      <UIcon :name="icon" class="size-6 shrink-0" :style="iconStyle" />
      <div>
        <h2 class="text-highlighted text-xl font-semibold">{{ title }}</h2>
        <p class="text-muted text-xs">{{ subtitle }}</p>
      </div>
    </div>
    <div class="flex items-center gap-2">
      <UButton
        label="Edit"
        :icon="ICON.edit"
        color="neutral"
        variant="outline"
        size="sm"
        @click="emit('edit')"
      />
      <UButton
        :icon="ICON.delete"
        color="error"
        variant="ghost"
        size="sm"
        square
        aria-label="Delete"
        @click="emit('delete')"
      />
    </div>
  </div>
</template>
